import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { provideFeatureAddonRoutes, provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { UserRole } from '@core/shared/access';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let MpfAppFrontendManagementFeature = /*#__PURE__*/(() => {
  let MpfAppFrontendManagementFeature = class MpfAppFrontendManagementFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/app/frontend-management","featureId":"mpf-app"};
    }
    getFeatureFunctionality(functionality) {
      const simpleAbilityCheck = {
        allow: [[UserRole.MANAGER, "Feature.mpf-courses.Manage"]]
      };
      functionality.defineMenuItems({
        managementToolbar: {
          basePath: 'management',
          items: [{
            label: 'Dashboard',
            routerLink: 'dashboard',
            icon: 'grip',
            simpleAbilityCheck,
            priority: 100
          }]
        }
      });
      functionality.defineRouterLinkRedirects([{
        matcher: '/management',
        redirect: (path, tree, resolve) => resolve('management-dashboard'),
        type: 'Redirect'
      }]);
      functionality.defineWidgets([{
        type: 'Dashboard',
        id: 'AppManagementHelpGuideWidget',
        priority: 10,
        name: 'Hilfe-Video',
        defaultVisibility: 'show',
        dashboardIds: ['management'],
        simpleAbilityCheck: ['MANAGER'],
        load: () => import('./widgets/management-guide.widget').then(m => m.AppManagementHelpGuideWidget),
        config: {}
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfAppFrontendManagementFeature_BaseFactory;
        return function MpfAppFrontendManagementFeature_Factory(__ngFactoryType__) {
          return (ɵMpfAppFrontendManagementFeature_BaseFactory || (ɵMpfAppFrontendManagementFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfAppFrontendManagementFeature)))(__ngFactoryType__ || MpfAppFrontendManagementFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfAppFrontendManagementFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'management/manager',
          redirectTo: 'management'
        } // catch legacy paths
        ]), provideFeatureAddonRoutes([{
          useAddonSlot: 'management',
          path: 'dashboard',
          loadComponent: () => import('./dashboard.component').then(mod => mod.MpfManagerDashboardComponent)
        }])],
        imports: [CommonModule]
      });
    }
  };
  MpfAppFrontendManagementFeature = __decorate([ClassName("MpfAppFrontendManagementFeature")], MpfAppFrontendManagementFeature);
  return MpfAppFrontendManagementFeature;
})();
export { MpfAppFrontendManagementFeature };